module.exports = __webpack_public_path__ + "img/icon_map_8_off_010.e37cb7dc.png";